export const MODAL_STYLES = { maxWidth: 400, marginX: "auto" };
